import { useQueryClient } from "@tanstack/react-query";
import { useAtom, useAtomValue } from "jotai";
import { useMemo, useState } from "react";
import { NOTIFICATION_TYPES } from "../constants";
import * as commentUtilities from "../stores/cohort/utils";
import { baseAtom } from "../stores/jotai/base";
import { discoverySessionAtom } from "../stores/jotai/discovery-session";
import * as notificationUtils from "../util/notification_utils";
import { markNotificationAsReadByIDs } from "../util/notificationAPIHelpers";

const useNotificationService = ({notificationData}) => {
    const [isMarkingAllNotificationsAsRead, setIsMarkingAllNotificationsAsRead] =
        useState<boolean>(false);

    const client=useQueryClient();
    const [base, setBase] = useAtom(baseAtom);

    const discoverySession = useAtomValue(discoverySessionAtom);
    const { user } = base;
    const allNotifications = notificationData || [];

    const isAllowedNotificationType = (payload) => {
        return payload?.type === NOTIFICATION_TYPES.AI_INSIGHT || payload?.type === NOTIFICATION_TYPES.EXPORT_TEAM_INTERVIEW;
    };

    const isNotificationCreatedByCurrentUser = (typeData) => {
        return (typeData?.userID || typeData?.data?.userID) === user.userID;
    };

    const filteredNotification = allNotifications.filter((notification) => {
        const typeData = notificationUtils.getNotificationPayload(notification);

        return (
            !isNotificationCreatedByCurrentUser(typeData) ||
            isAllowedNotificationType(typeData)
        );
    });

    const notifications =
        commentUtilities.orderNotifications(filteredNotification);

    const unseenNotifications = useMemo(() => {
        return notifications.filter((notification) => notification?.seen !== 1)
            .length;
    }, [notifications]);

    const handleMarkAllNotificationsAsRead = () => {
        const notificationIDs = notifications
            .filter((notificaiton) => notificaiton.seen !== 1)
            .map((notificaiton) => notificaiton.notificationID);

        if (notificationIDs.length > 0) {
            setIsMarkingAllNotificationsAsRead(true);

            markNotificationAsReadByIDs(notificationIDs, discoverySession, () => {
                client.invalidateQueries({ queryKey: ["notifications"] });
                setIsMarkingAllNotificationsAsRead(false);
            });
        }
    };

    return {
        allNotifications,
        notifications,
        unseenNotifications,
        handleMarkAllNotificationsAsRead,
        isMarkingAllNotificationsAsRead,
        setIsMarkingAllNotificationsAsRead,
    };
};

export default useNotificationService;
